import { Button, Col, Form, Row, Select } from "antd";
import React, { useState } from "react";
import FilterContainer from "../../../../../components/common/FilterContainer";
import PageHeading from "../../../../../components/common/PageHeading";

const NewBankDeposit = () => {
  const [visible, setVisible] = useState(false);
  return (
    <div>
      <PageHeading heading="New Bank Deposit" />
      <Row>
        <Col span={24}>
          <FilterContainer
            heading={
              "To view receipts to deposit, select a bank account and click Search."
            }
          >
            <Form
              name="basic"
              labelCol={{
                span: 6,
              }}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              autoComplete="off"
              colon={false}
            >
              <Row>
                <Col span={8} offset={6}>
                  <Form.Item label="Bank Account ">
                    <Select
                      showSearch
                      options={[
                        { value: "All" },
                        { value: "Rental Income Account" },
                        { value: "Security Deposit" },
                      ]}
                      defaultValue="All"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8} offset={6}>
                  <Form.Item label="User ">
                    <Select
                      showSearch
                      options={[
                        { value: "All" },
                        { value: "Aamir@sayeagle.com" },
                        { value: "Kashif@sayeagle.com" },
                        { value: "Seerat@sayeagle.com" },
                        { value: "Rimsha@sayeagle.com" },
                      ]}
                      defaultValue="All"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8} offset={8}>
                  <Button type="primary" onClick={() => setVisible(true)}>
                    Search
                  </Button>
                </Col>
              </Row>
            </Form>
          </FilterContainer>
        </Col>
      </Row>
      {visible ? (
        <Row justify="center">
          <Col>
            <p>
              There are no undeposited receipts that match your criteria.
              Receipts that are available for deposit will appear here after
              they are entered on the Enter Receipt page.
            </p>
          </Col>
        </Row>
      ) : (
        ""
      )}
       <div className="RightSidebar">
      </div>
    </div>
  );
};

export default NewBankDeposit;
